<template lang="html">
<div>
  <div v-show="showIsSpeaking" class="bottom-0 w-full rounded-md border-t-4 shadow bg-white px-2 py-4 mb-2" :class="speaking.isSpeaking ? 'border-blue-500': 'border-gray-400'">
    <div class="font-medium text-gray-600 leading-none">
      <div class="flex space-x-2 items-center">
        <div>
          <div class="w-8 h-8 bg-gray-200 rounded-full"></div>
        </div>
        <div class="flex-grow">
          <p class="font-medium text-gray-800 role capitalize">{{speaking.role}}</p>
          <p class="text-sm bold text-blue-500">
            {{ speaking.name }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="relative overflow-y-scroll bg-gray-50 dark:bg-gray-800 rounded-lg shadow-inner p-2 h-full">
      <div v-if="connected_peers.length">
        <transition-group name="slide-in" class="grid gap-2" :class="peerColumns">
          <participant :ref="'peer_' + peer.public_key" class="slide-in-item" :peer="peer" :callingPeer="callingPeer"
                       :showActions="showActions"
                       v-on:removePeer="onRemovePeer(peer.public_key)"
                       v-on:speaking="onSpeaking(peer.public_key)"
                       v-for="peer in connected_peers" v-if="peer.showInUI" :key="peer.public_key"></participant>
        </transition-group>
      </div>
      <div class="text-gray-600 flex justify-center items-center h-full" v-else>
        <div class="text-center">
          Nobody is here yet
        </div>
      </div>
      <!-- hidden participants, (Host inAnyhwere) -->
      <div class="hidden">
          <participant :ref="'peer_' + peer.public_key" class="slide-in-item" :peer="peer" :callingPeer="callingPeer"
                       :showActions="showActions"
                       v-on:sendPeerList="sendRoomStatus" v-on:callingPeer="onCallingPeer"
                       v-on:removePeer="onRemovePeer(peer.public_key)"
                       v-on:speaking="onSpeaking(peer.public_key)"
                       v-for="peer in connected_peers" v-if="!peer.showInUI" :key="peer.public_key"></participant>
        </div>
    </div>
  </div>
</template>

<script>

import {notify, localNotify} from 'utils/notifications'
import messageBroker from 'general/messageBroker';
import Participant from './participant.vue'
import { addNewPeer, updatePeer, removePeer, setupSpeaking, onSpeaking } from "common/participant"

export default {
  props: {
    isHost: false,
  },
  components: {
    Participant
  },
  data() {
    return {
      connected_peers: [],
      started: false,
      inRoom: {},
      callingPeer: false,
      showActions: false,
      showIsSpeaking: false,
      speaking: {
        isSpeaking: false,
        name: "Nobody is speaking",
        role: "-"
      },
    }
  },
  computed: {
    peerColumns() {
      let columns = 'grid-cols-' + (this.connected_peers.length > 1 ? 2 : 1)
      if (product == 'anywhere' || role == 'host') columns = 'grid-cols-1'
      return columns
    }
  },
  mounted() {
    this.showIsSpeaking == product == "mirror"

    messageBroker
      .registerNewMessageType('participant-list', (data) => {
        // update participant list ma boy
        console.log("hello")
      })
    messageBroker.registerNewMessageType('ptt', (data) => {
      // show participant talking
      if (data.message.enabled == false){
        this.speaking = {
          isSpeaking: false,
          name: "Nobody is speaking",
          role: "-"
        }
      }
    });


    window.setInterval(()=> {
      if (this.speaking.timeout < Date.now()){
        this.speaking = {
          isSpeaking: false,
          name: "Nobody is speaking",
          role: "-"
        }
      }
    }, 1000)
  },
  methods: {
    addNewPeer(newPeer) {
      this.connected_peers = addNewPeer(newPeer);
    },
    removePeer(pk){
      this.connected_peers = removePeer(this.connected_peers, pk)
    },
    updatePeer(peerData){
      this.connected_peers = updatePeer(peerData)
    },
    onSpeaking(public_key){
      onSpeaking(public_key, (data) => {
        this.speaking = data;
      });
    },
    getPeerConnectionComponent(public_key) {
      const ref = this.$refs['peer_' + public_key]
      if (ref == undefined) return;
      return this.$refs['peer_' + public_key][0]
    },
    getPeerConnection(public_key) {
      let peer = this.connected_peers.filter(peer => peer.public_key == public_key)[0]
      if (peer == null) return null;
      peer.component = this.getPeerConnectionComponent(public_key);
      return peer;
    },
  }
}
</script>
<style lang="">

</style>
